<template>
  <div class="page-content"><slot></slot></div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/content/index.vue